import { Role } from '@/types/user.type'
import { useAuthContext } from '@/contexts/auth-context/auth-provider'

import DashboardShopView from '../dashboard-shop-view'
import DashboardAdminView from '../dashboard-admin-view'

export default function DashboardView() {
  const { user } = useAuthContext()

  const isRenderDashboard = user?.role === Role.ADMIN

  return (
    <>{isRenderDashboard ? <DashboardAdminView /> : <DashboardShopView />}</>
  )
}
